import { Link } from "@tanstack/react-router";
import { SalerioLogo } from "@/assets/images";
import { ROUTES } from "@/config/constants";
import { useAuthContext } from "@/auth/AuthProvider";
import { MoreVertMenu } from "./components/MoreVertMenu";
import { PersonMenu } from "./components/PersonMenu";
import { useExceptionsCounter } from "./hooks/useExceptionsCounter";
import { formatExceptionsCount } from "@/shared/utils/formatExceptionsCount";

export function Header() {
  const { isAuthenticated } = useAuthContext();
  const exceptionsCount = useExceptionsCounter();

  return (
    <header className="h-[89px] bg-[#113045] border-b border-border flex items-center justify-between px-16">
      <Link to={ROUTES.HOME} className="cursor-pointer">
        <SalerioLogo className="h-10" />
      </Link>
      {isAuthenticated && (
        <div className="flex items-center gap-8">
          <Link
            to={ROUTES.HOME}
            aria-label="notifications"
            className={
              exceptionsCount === 0
                ? "h-6 w-6 flex items-center justify-center rounded-full bg-[#113045] cursor-pointer hover:opacity-50 active:opacity-50"
                : "h-6 min-w-6 px-1.5 flex items-center justify-center rounded-full bg-[#ffffff] text-[12px] font-medium cursor-pointer hover:opacity-50 active:opacity-50"
            }
          >
            {exceptionsCount === 0 ? (
              <span
                className="material-symbols-outlined text-2xl leading-none text-green"
                style={{ fontVariationSettings: "'FILL' 1" }}
              >
                check_circle
              </span>
            ) : (
              formatExceptionsCount(exceptionsCount)
            )}
          </Link>
          <span className="material-symbols-outlined text-2xl leading-none text-[#FFFFFF] cursor-pointer hover:opacity-50 active:opacity-50">
            help
          </span>
          <MoreVertMenu />
          <PersonMenu />
        </div>
      )}
    </header>
  );
}
